import type { ProductPurchasesListRow } from "@/admin/entities/productPurchases";
import type { ProductPurchasesListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: ProductPurchasesListRow[];
  count: number;
} {
  const productPurchases = (data as ProductPurchasesListQueryType)
    ?.productPurchases;
  if (!productPurchases || !productPurchases.nodes) {
    return { nodes: [], count: 0 };
  }
  return productPurchases;
}

export function mapColumns(purchase: ProductPurchasesListRow) {
  return [
    purchase.id,
    purchase.type,
    purchase,
    purchase,
    purchase,
    purchase,
    purchase.startAt,
    purchase.expiredAt,
    purchase.refunded,
    purchase.disputed,
    purchase,
    purchase,
  ];
}
